import React from 'react';
import { utility } from '../framework/utility/utilityProvider';
import { MAM_STATUS } from '../framework/constant/constant';
import MyStatusCell from './MyStatusCell';

const MAMStatusCell = (props) => {
    const { dataItem, field } = props;
    const statusValue = utility.getNestedValue(dataItem, field);

    let title = utility.getKeyByValue(MAM_STATUS, statusValue);
    let tileBackColor = "";
    let titleColor = "white";

    switch (statusValue) {
        case MAM_STATUS.Pending:
            title = title;
            tileBackColor = "#727B84";
            break;
        case MAM_STATUS.Ingesting:
            title = title;
            tileBackColor = "#FE9328";
            break;
        case MAM_STATUS.Ingested:
            title = title;
            tileBackColor = "#11D2F2";
            break;
        case MAM_STATUS.Transcoding:
            title = title;
            tileBackColor = "#7A25F7";
            break;
        case MAM_STATUS.TXReady:
            title = title;
            tileBackColor = "#63AA43";
            break;
        default:
            title = "N/A";
            tileBackColor = "#9CA3AF";
            break;
    }

    return (
        <MyStatusCell {...props} title={title} titleColor={titleColor} tileBackColor={tileBackColor} />
    );
};

export default MAMStatusCell;